enum KindOfResearch {
  "One-on-One" = 1,
  "Focus Group" = 2,
  "Multi Day Study" = 3,
  "Unmoderated Study" = 4,
  "Phone Interview" = 5,
  "Usability Testing" = 6,
  "In Respondent Home" = 8,
  "Survey" = 9,
  "Diary Study" = 10,
  "In Respondent Office" = 11,
}

export function isModeratedStudy({
  project,
}: {
  project: { kindOfResearch: number };
}): boolean {
  return [
    KindOfResearch["One-on-One"],
    KindOfResearch["Focus Group"],
    KindOfResearch["In Respondent Home"],
    KindOfResearch["In Respondent Office"],
  ].includes(project.kindOfResearch);
}
